import { Form } from 'react-bootstrap';

const FormLabel = ({ children }) => (
	<Form.Label column lg={3} className="text-lg-end mb-0">
		{children}
	</Form.Label>
);

export default FormLabel;
